// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"8f1346c7","670":"4aae6060"}[chunkId] + ".chunk.js";
};